import {
  Toast
} from "./chunk-PXK4GIBT.mjs";
import {
  observer
} from "./chunk-KZDHNNVD.mjs";
import {
  __spreadValues
} from "./chunk-3IID4MV4.mjs";

// src/Toaster.tsx
import { Fragment, useEffect, useState } from "react";
import { flushSync } from "react-dom";
import { jsx } from "@emotion/react/jsx-runtime";
function Toaster(props) {
  const [toasts, setToasts] = useState([]);
  useEffect(() => {
    function subscriber(toast) {
      const indexOfExistingToast = toasts.findIndex((t) => t.id === toast.id);
      if (toast.delete) {
        setToasts((prevToasts) => prevToasts.filter((t) => t.id !== toast.id));
        return;
      }
      flushSync(() => {
        setToasts((prevToasts) => {
          if (indexOfExistingToast === -1) {
            return [...prevToasts, toast];
          }
          const newToasts = [...prevToasts];
          newToasts[indexOfExistingToast] = toast;
          return newToasts;
        });
      });
    }
    observer.subscribe(subscriber);
    return () => {
      observer.unsubscribe(subscriber);
    };
  }, [toasts]);
  return /* @__PURE__ */ jsx(Fragment, { children: toasts.map((toast) => /* @__PURE__ */ jsx(Toast, __spreadValues(__spreadValues({}, props), toast), toast.id)) });
}

export {
  Toaster
};
